import { ApiPlugin } from '@/plugins';

export default class thematicCardPageProfondeService {
  static async fetchThematicCardsLinks({
    index = 'thematic_card',
    what = '*:*',
    regionsFilter = window?.drupalSettings?.sante_thematic_card?.links?.regions_filter,
    contentTargetFilter = window?.drupalSettings?.sante_thematic_card?.links?.content_target_filter,
    withoutHighlight = 1,
  }) {
    const params = {
      index,
      what,
      regions_filter: JSON.stringify(regionsFilter),
      content_target_filter: JSON.stringify(contentTargetFilter),
      withoutHighlight,
    };
    const response = await ApiPlugin.get('/solr/request/ajax/', { params });
    return response.data;
  }

  static getThematicCardPageProfondeDrupalSettings() {
    const data = {
      links: window?.drupalSettings?.sante_thematic_card?.links,
      content_type: window?.drupalSettings?.sante_thematic_card?.content_type,
      regions_filter: window?.drupalSettings?.sante_thematic_card?.links?.regions_filter,
      content_target_filter: window?.drupalSettings?.sante_thematic_card?.links?.content_target_filter,
    };
    if (!data) {
      console.error('No data from DrupalSeetings.sante_thematic_card.');
      return {};
    }
    return data;
  }
}
